"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _ReactAnimation = _interopRequireDefault(require("./ReactAnimation.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Arrows = (0, _component.default)(() => import("./Arrows"));
const Bullets = (0, _component.default)(() => import("./Bullets"));
const Slider = (0, _component.default)(() => import("./Slider"));
const Texts = (0, _component.default)(() => import("./SlideItem/Texts"));
const ReactAnimation = _ref => {
  let {
    absoluteMediaURLs = false,
    api,
    data,
    id,
    hideTexts = false,
    lang = "de",
    mediaFormats,
    onSlideChange,
    prevIcon,
    nextIcon,
    showArrows = false,
    showBlurredBackground = false,
    showBullets = false,
    texts,
    textComponents,
    textVariants,
    webpFallback = false
  } = _ref;
  const [options = {}, setOptions] = (0, _react.useState)({});
  const [slide, setSlide] = (0, _react.useState)(null);
  const [timestamp, setTimestamp] = (0, _react.useState)(null);
  const [touchStart, setTouchStart] = (0, _react.useState)(null);
  const [touchEnd, setTouchEnd] = (0, _react.useState)(null);
  const {
    entries = 0,
    items = [],
    sequence
  } = options;
  const _animationRef = (0, _react.useRef)();
  const _animationTimer = (0, _react.useRef)();
  const _isPlaying = (0, _react.useRef)();
  const css = (0, _ReactAnimation.default)();
  const minSwipeDistance = 50;
  (0, _react.useEffect)(() => {
    if ((0, _isEmpty.default)(data)) return;
    setOptions(data);
  }, [data]);
  (0, _react.useEffect)(() => {
    if ((0, _isEmpty.default)(options) || entries === 0) return;
    clearTimeout(_animationTimer.current);
    _isPlaying.current = true;
    setSlide(0);
    setTimestamp(new Date().getTime());
  }, [entries, options]);
  (0, _react.useEffect)(() => {
    play();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slide, timestamp]);
  (0, _react.useEffect)(() => {
    if (data) return;
    const fetchData = async () => {
      let fetchURL = "".concat(api, "?lang=").concat(lang);
      if (id) fetchURL += "&id=".concat(id);
      const response = await fetch(fetchURL);
      if (response.status !== 200) {
        throw new Error("No animation found!");
      }
      const data = await response.json();
      setOptions(data);
      return data;
    };
    fetchData();
  }, [api, data, id, lang]);
  const handleChange = id => {
    _isPlaying.current = true;
    const slideID = id !== null && id !== void 0 ? id : slide + 1;
    if (slideID >= entries) {
      setSlide(0);
      return;
    }
    setSlide(slideID);
  };
  const play = () => {
    var _items$slide$duration, _items$slide;
    if (!_isPlaying.current) return;
    clearTimeout(_animationTimer.current);
    const duration = (_items$slide$duration = items === null || items === void 0 || (_items$slide = items[slide]) === null || _items$slide === void 0 ? void 0 : _items$slide.duration) !== null && _items$slide$duration !== void 0 ? _items$slide$duration : 5000;
    let newIndex = slide + 1;
    if (slide === entries - 1) {
      newIndex = 0;
    }
    _animationTimer.current = setTimeout(() => {
      setSlide(newIndex);
    }, duration);
  };
  const stop = () => {
    _isPlaying.current = false;
    clearTimeout(_animationTimer.current);
  };
  (0, _react.useEffect)(() => {
    if (items.length > 0 && typeof slide === "number" && typeof onSlideChange === "function") {
      onSlideChange(items === null || items === void 0 ? void 0 : items[slide]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slide, items]);
  const onTouchStart = e => {
    setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX);
  };
  const onTouchMove = e => setTouchEnd(e.targetTouches[0].clientX);
  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe) {
      handleChange(slide + 1);
    }
    if (isRightSwipe) {
      const counter = slide - 1;
      if (counter < 0) {
        handleChange(entries - 1);
        return;
      }
      handleChange(counter);
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.animation, "mco-animation-01"),
    ref: _animationRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.wrapper, "mco-animation-01__wrapper"),
    onTouchStart: onTouchStart,
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd
  }, entries > 0 && /*#__PURE__*/_react.default.createElement(Slider, {
    absoluteMediaURLs: absoluteMediaURLs,
    active: slide,
    animationRef: _animationRef,
    hideTexts: hideTexts,
    items: items,
    mediaFormats: mediaFormats,
    playAnimation: handleChange,
    sequence: sequence,
    showBlurredBackground: showBlurredBackground,
    stopAnimation: stop,
    textStyles: {
      textComponents,
      textVariants
    },
    webpFallback: webpFallback
  }), !(0, _isEmpty.default)(texts) && !hideTexts && /*#__PURE__*/_react.default.createElement(Texts, {
    duration: -1,
    show: true,
    texts: texts,
    textStyles: {
      textComponents,
      textVariants
    }
  }), showArrows && entries > 1 && /*#__PURE__*/_react.default.createElement(Arrows, {
    active: slide,
    entries: entries,
    prevIcon: prevIcon,
    nextIcon: nextIcon,
    onChange: id => handleChange(id)
  }), showBullets && entries > 1 && /*#__PURE__*/_react.default.createElement(Bullets, {
    active: slide,
    counter: entries,
    onChange: id => handleChange(id)
  })));
};
ReactAnimation.propTypes = {
  absoluteMediaURLs: _propTypes.default.bool,
  api: _propTypes.default.string,
  data: _propTypes.default.object,
  hideTexts: _propTypes.default.bool,
  id: _propTypes.default.number,
  lang: _propTypes.default.string,
  mediaFormats: _propTypes.default.object,
  onSlideChange: _propTypes.default.func,
  prevIcon: _propTypes.default.object,
  nextIcon: _propTypes.default.object,
  showArrows: _propTypes.default.bool,
  showBlurredBackground: _propTypes.default.bool,
  showBullets: _propTypes.default.bool,
  texts: _propTypes.default.array,
  textComponents: _propTypes.default.object,
  textVariants: _propTypes.default.object,
  webpFallback: _propTypes.default.bool
};
var _default = exports.default = ReactAnimation;